import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";
import styles from "../../gmanewstyle.module.css";
import logoimage from "../assets/Group -2.png";
import PortalSidebar from "../PortalSidebar/PortalSidebar";

// Reusable Pagination component
const Pagination = ({
  currentPage,
  totalRecords,
  recordsPerPage,
  onPageChange,
}) => {
  const start = (currentPage - 1) * recordsPerPage + 1;
  const end = Math.min(start + recordsPerPage - 1, totalRecords);
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  return (
    <div className={styles.pagination}>
      <button
        className={`${styles.pageBtn} ${styles.pageBtnPrimary}`}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Previous
      </button>
      <span className={styles.pageMeta}>
        {start}-{end} of {totalRecords}
      </span>
      <button
        className={`${styles.pageBtn} ${styles.pageBtnPrimary}`}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default function ContractorDetailPage() {
  const { id, buildingId } = useParams();
  const navigate = useNavigate();
  const buildingname = localStorage.getItem("buildingName");
  const [contractor, setContractor] = useState(null);
  const [payments, setPayments] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const tabs = ["General", "Payments", "Awarded Contracts", "Quotes"];
  const [activeTab, setActiveTab] = useState("General");
  const recordsPerPage = 10;
  const [payPage, setPayPage] = useState(1);
  const [jobPage, setJobPage] = useState(1);
  const [quotePage, setQuotePage] = useState(1);

  // Format date or fallback
  const fmtDate = (d) => {
    try {
      return format(new Date(d), "dd MMM yyyy hh:mm");
    } catch {
      return d || "—";
    }
  };

  function formatAmountWithSpace(num) {
    if (num == null || isNaN(num)) return "—";
    const [intPart, decPart] = Number(num).toFixed(2).split(".");
    const withSpaces = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return `${withSpaces},${decPart}`;
  }

  function getRelatedRecord(p) {
    const paymentType = (
      p["cr446_paymenttype@OData.Community.Display.V1.FormattedValue"] || ""
    ).toLowerCase();
    if (paymentType.includes("maintenance")) {
      return (
        p[
          "_cj_linkedmaintenancerecord_value@OData.Community.Display.V1.FormattedValue"
        ] ||
        p._cj_linkedmaintenancerecord_value ||
        "—"
      );
    }
    if (paymentType.includes("legal")) {
      return (
        p[
          "_cj_linkedlegalrecord_value@OData.Community.Display.V1.FormattedValue"
        ] ||
        p._cj_linkedlegalrecord_value ||
        "—"
      );
    }
    if (paymentType.includes("account")) {
      return (
        p["_cj_accountt_value@OData.Community.Display.V1.FormattedValue"] ||
        p._cj_accountt_value ||
        "—"
      );
    }
    if (paymentType.includes("contractor")) {
      return (
        p[
          "_cr446_contractorname_value@OData.Community.Display.V1.FormattedValue"
        ] ||
        p._cr446_contractorname_value ||
        "—"
      );
    }
    return "—";
  }

  function getRelatedRoute(p) {
    const paymentType = (
      p["cr446_paymenttype@OData.Community.Display.V1.FormattedValue"] || ""
    ).toLowerCase();
    if (
      paymentType.includes("maintenance") &&
      p._cj_linkedmaintenancerecord_value
    ) {
      return `/maintenance/${p._cj_linkedmaintenancerecord_value}/${buildingId}`;
    }
    if (paymentType.includes("legal") && p._cj_linkedlegalrecord_value) {
      return `/legal/${p._cj_linkedlegalrecord_value}/${buildingId}`;
    }
    if (paymentType.includes("account") && p._cj_accountt_value) {
      return `/account/${p._cj_accountt_value}/${buildingId}`;
    }
    if (paymentType.includes("contractor") && p._cr446_contractorname_value) {
      return `/contractor/${p._cr446_contractorname_value}/${buildingId}`;
    }
    return null; // no click for other types
  }

  const [userAccess, setUserAccess] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);

  const [displayName, setDisplayName] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Default sidebar state based on device width
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

useEffect(() => {
  const handleResize = () => {
    const desktop = window.innerWidth >= 1024;
    setIsDesktop(desktop);

    // Only force closed when moving to smaller screens.
    // On desktop, keep whatever state the user last chose.
    if (!desktop) {
      setSidebarOpen(false);
    }
  };

  handleResize();
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);
  useEffect(() => {
  function handleClick(e) {
    // On desktop/laptop, only the burger should control the sidebar
    if (isDesktop) return;

    const sidebar = document.getElementsByClassName(styles.sidebar)[0];
    const hamburger = document.getElementsByClassName(styles.menuBtn)[0];

    if (!sidebar || !hamburger) return;

    const clickedInsideSidebar = sidebar.contains(e.target);
    const clickedHamburger = hamburger.contains(e.target);

    if (sidebarOpen && !clickedInsideSidebar && !clickedHamburger) {
      setSidebarOpen(false);
    }
  }

  document.addEventListener("click", handleClick);
  return () => document.removeEventListener("click", handleClick);
}, [sidebarOpen, isDesktop]);

  // pull user access for top-right dropdown
  useEffect(() => {
    const fetchUserAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }

      try {
        const decoded = JSON.parse(atob(token.split(".")[1]));
        const { email, contact_id, firstname, lastname, name } = decoded || {};

        // Set display name safely
        const fullName =
          firstname && lastname
            ? `${firstname} ${lastname}`
            : name
            ? name
            : email || "User";

        setDisplayName(fullName);

        if (!email) {
          setLoadingAccess(false);
          return;
        }

        const resp = await fetch(
          "https://portal.gmacc.co.za/api/contact/determine-access/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email, contact_id }),
          }
        );

        const data = await resp.json();
        if (resp.ok) {
          setUserAccess(data.access || []);
        }
      } catch (err) {
        console.error("Failed to fetch access:", err);
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchUserAccess();
  }, [navigate]);

  const handleOwnerPortalClick = () => navigate("/owner-portal");
  const handleTrusteePortalClick = () => navigate("/trustee-portal");

  // Load contractor + related lists
  useEffect(() => {
    document.title = "Loading contractor…";
    const token = localStorage.getItem("token");
    if (!token) return navigate("/");

    (async () => {
      try {
        const [cRes, pRes, jRes, qRes] = await Promise.all([
          fetch(`https://portal.gmacc.co.za/api/contractors/${id}/`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(
            `https://portal.gmacc.co.za/api/contractors/${id}/payments/${buildingId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          ),
          fetch(
            `https://portal.gmacc.co.za/api/contractors/${id}/maintenance/${buildingId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          ),
          fetch(
            `https://portal.gmacc.co.za/api/contractors/${id}/quotes/${buildingId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          ),
        ]);
        if (!cRes.ok) throw new Error();
        const cJson = await cRes.json();
        setContractor(cJson);

        const pJson = await pRes.json();
        setPayments(pJson.value || []);

        const jJson = await jRes.json();
        setJobs(jJson.value || []);

        const qJson = await qRes.json();
        setQuotes(Array.isArray(qJson) ? qJson : qJson.value || []);

        document.title = `${cJson.cj_name} • Contractor Detail`;
      } catch {
        setError("Could not load contractor.");
      } finally {
        setLoading(false);
      }
    })();
  }, [id, buildingId, navigate]);

  if (loading)
    return (
      <div className={styles.page}>
        <div className={styles.shell}>
          <main className={styles.contentArea}>
            <div className={styles.panel}>
              <div className={styles.loadingContainer}>
                <div className={styles.loadingImage}></div>
                <p className={styles.loadingText}>Loading...</p>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  if (error) return <p className={styles.errorText}>{error}</p>;
  if (!contractor) return null;

  // Sort payments descending by payment number
  const sortedPayments = [...payments].sort((a, b) =>
    b.cr446_paymentpk.localeCompare(a.cr446_paymentpk)
  );

  // Fields for General tab
  const generalFields = [
    ["Name", contractor.cj_name],
    ["Trading As", contractor.cr446_tradingas],
    [
      "Specialty",
      contractor[
        "cj_contractorspeciality@OData.Community.Display.V1.FormattedValue"
      ],
    ],
    [
      "Status",
      contractor[
        "cj_contractorstatus@OData.Community.Display.V1.FormattedValue"
      ],
    ],
    ["Email", contractor.emailaddress],
    ["Phone", contractor.cj_companytelephone],
    ["Registration Number", contractor.cj_registrationnumber],
    ["VAT Number", contractor.cj_vatnumber],
    ["Website", contractor.cj_website],
    ["Address 1", contractor.cj_address1],
    ["Address 2", contractor.cj_address2],
    ["City", contractor.cj_city],
    ["Postal Code", contractor.cj_postalcode],
    ["Comment", contractor.cr446_comment],
  ];
const handleLandlordPortalClick = () => {
    localStorage.setItem("rental_portal_mode", "landlord");
    navigate("/rental-portal");
  };

  const handleTenantPortalClick = () => {
    localStorage.setItem("rental_portal_mode", "tenant");
    navigate("/rental-portal");
  };

  return (
    <div className={styles.page}>
      {/* NAVBAR */}
      <header className={styles.topbar}>
        <div className={styles.topbarLeft}>
          <img src={logoimage} alt="GMA Logo" className={styles.topLogo} />

          {/* HAMBURGER: opens/closes sidebar */}
          <button
            type="button"
            className={styles.menuBtn}
            onClick={() => setSidebarOpen((v) => !v)}
          >
            ☰
          </button>

          <h1 className={styles.topTitle}>
            {buildingname} - {contractor.cj_name}
          </h1>
        </div>

        {/* USER CHIP: opens dropdown */}
        <div
          className={styles.userChip}
          onClick={() => {
            navigate("/user-profile");
          }}
          style={{ cursor: "pointer" }}
        >
          <span className={styles.statusDot}></span>
          <span className={styles.userName}>{displayName} ▾</span>
        </div>
      </header>

      <div className={styles.shell}>
        <PortalSidebar
  activePortal="trustee"
  activeTab="buildings"
  userAccess={userAccess}
  loadingAccess={loadingAccess}
  sidebarOpen={sidebarOpen}
  ticketRole="trustee"
/>
        <main className={styles.contentArea}>
          <div className={styles.panel}>
            {/* Top: Contractor */}
            <div className={styles.paymentCardGrid}>
              <table className={styles.topTable}></table>
            </div>

            {/* Tabs */}
            <div className={styles.subTabs}>
              {tabs.map((tab) => (
                <div
                  key={tab}
                  className={
                    activeTab === tab ? styles.subTabActive : styles.subTab
                  }
                  onClick={() => {
                    setActiveTab(tab);
                    setPayPage(1);
                    setJobPage(1);
                    setQuotePage(1);
                  }}
                >
                  {tab}
                </div>
              ))}
            </div>

            {/* Content */}
            <div className={styles.paymentCardGrid}>
              {activeTab === "General" && (
                <div className={styles.paymentCardDark}>
                  <h2>General</h2>
                  {generalFields.map(([label, val]) =>
                    val == null || String(val).trim() === "" ? null : (
                      <div key={label} className={styles["input-group"]}>
                        <h3>{label}:</h3>
                        <input readOnly value={val} />
                      </div>
                    )
                  )}
                </div>
              )}

              {activeTab === "Payments" && (
                <div className={styles.paymentCard}>
                  <h2 className={styles.cardSectionTitleLight}>Payments</h2>

                  <div className={styles.responsiveTableWrapper}>
                    <table className={styles.dataTable}>
                      <thead>
                        <tr>
                          <th>Payment Number</th>
                          <th>Type</th>
                          <th>Related Record</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedPayments
                          .slice(
                            (payPage - 1) * recordsPerPage,
                            payPage * recordsPerPage
                          )
                          .map((p) => {
                            const route = getRelatedRoute(p);
                            const label = getRelatedRecord(p);
                            return (
                              <tr key={p.cr446_paymentpk}>
                                <td
                                  className={styles.relatedLink}
                                  onClick={() =>
                                    navigate(
                                      `/payment/${p.cr446_paymentid}/${buildingId}`
                                    )
                                  }
                                >
                                  {p.cr446_paymentpk}
                                </td>
                                <td>
                                  {
                                    p[
                                      "cr446_paymenttype@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  }
                                </td>
                                <td
                                  className={
                                    route ? styles.paymentNumberCell : ""
                                  }
                                  style={route ? { cursor: "pointer" } : {}}
                                  onClick={
                                    route ? () => navigate(route) : undefined
                                  }
                                >
                                  {label}
                                </td>
                                <td className={styles.amountCell}>
                                  <span>
                                    {formatAmountWithSpace(p.cr446_amount)}
                                  </span>
                                </td>
                                <td>
                                  {
                                    p[
                                      "cj_progress@OData.Community.Display.V1.FormattedValue"
                                    ]
                                  }
                                </td>
                                <td>
                                  {fmtDate(p.cj_paymenttime || p.createdon)}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <Pagination
                    currentPage={payPage}
                    totalRecords={payments.length}
                    recordsPerPage={recordsPerPage}
                    onPageChange={setPayPage}
                  />
                </div>
              )}

              {activeTab === "Awarded Contracts" && (
                <div className={styles.paymentCard}>
                  <h2 className={styles.cardSectionTitleLight}>
                    Awarded Contracts
                  </h2>

                  <div className={styles.responsiveTableWrapper}>
                    <table className={styles.dataTable}>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Progress</th>
                          <th>Type</th>
                          <th>Description</th>
                          <th>Invoice</th>
                        </tr>
                      </thead>
                      <tbody>
                        {jobs
                          .slice(
                            (jobPage - 1) * recordsPerPage,
                            jobPage * recordsPerPage
                          )
                          .map((job) => (
                            <tr key={job.cj_maintenancebid}>
                              <td
                                className={styles.relatedLink}
                                onClick={() =>
                                  navigate(
                                    `/maintenance/${job.cj_maintenancebid}/${buildingId}`
                                  )
                                }
                              >
                                {job.cj_name}
                              </td>
                              <td>
                                {
                                  job[
                                    "cj_progress@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                              <td>
                                {
                                  job[
                                    "cj_maintenanacetype@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>
                              <td>{job.cj_fulldescription}</td>
                              <td>
                                {job.cj_invoicelink ? (
                                  <a
                                    href={job.cj_invoicelink}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Download
                                  </a>
                                ) : (
                                  "—"
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <Pagination
                    currentPage={jobPage}
                    totalRecords={jobs.length}
                    recordsPerPage={recordsPerPage}
                    onPageChange={setJobPage}
                  />
                </div>
              )}

              {activeTab === "Quotes" && (
                <div className={styles.paymentCard}>
                  <h2 className={styles.cardSectionTitleLight}>Quotes</h2>

                  <div className={styles.responsiveTableWrapper}>
                    <table className={styles.dataTable}>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Maintenance Job</th>
                          <th>Amount</th>
                          <th>File Link</th>
                        </tr>
                      </thead>
                      <tbody>
                        {quotes
                          .slice(
                            (quotePage - 1) * recordsPerPage,
                            quotePage * recordsPerPage
                          )
                          .map((q) => (
                            <tr key={q.quote_id}>
                              <td>{q.cj_name || q.quote_name}</td>

                              <td
                                className={styles.relatedLink}
                                onClick={() =>
                                  navigate(
                                    `/maintenance/${q._cj_maintenancejobassignment_value}/${buildingId}`
                                  )
                                }
                              >
                                {
                                  q[
                                    "_cj_maintenancejobassignment_value@OData.Community.Display.V1.FormattedValue"
                                  ]
                                }
                              </td>

                              <td className={styles.amountCell}>
                                <span>
                                  {formatAmountWithSpace(q.cj_amount)}
                                </span>
                              </td>

                              <td>
                                {q.cj_quotelink ? (
                                  <a
                                    href={q.cj_quotelink}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    View
                                  </a>
                                ) : (
                                  "—"
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <Pagination
                    currentPage={quotePage}
                    totalRecords={quotes.length}
                    recordsPerPage={recordsPerPage}
                    onPageChange={setQuotePage}
                  />
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
